import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { FilterContext, FilterDispatchContext } from "../context/FilterContext";
import { FilterDataState, FilterComponentProps, ChartComponentProps, CustomTooltipProps } from '../types/type';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default ({
    sectionType
}: FilterComponentProps) => {
    const filterState = useContext(FilterContext);
    const filterDispatchState = useContext(FilterDispatchContext);

    const SubTypesFilter = () => {
        const subtypeInputs = []

        const createSubTypeInput = (
            number,
            selectedParent
        ) => {
            if(filterState.filterData.typeData.find((data) => selectedParent === data.ParentID.toString())) {
                let value = filterState.selectedCategorySubtypes ? filterState.selectedCategorySubtypes[number] : undefined;
                return (
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridState">
                            <Form.Label>Sub-Categoria {number} </Form.Label>
                            <Form.Control as="select" defaultValue="-" value={value} onChange={(e) => {
                                let newSelectedCategorySubtypes = {...filterState.selectedCategorySubtypes, [number]: e.target.value}

                                for (let key of Object.keys(newSelectedCategorySubtypes)) {
                                    if (key > number) {
                                        delete newSelectedCategorySubtypes[key]
                                    }
                                }
                                
                                filterDispatchState({
                                    ...filterState,
                                    selectedCategorySubtypes: newSelectedCategorySubtypes,
                                    selectedType: e.target.value
                                })
                            }}>
                                <option value={"0"}>-</option>
                                {
                                    filterState.filterData && filterState.filterData.typeData.filter((data) => {
                                        if (selectedParent) return data.ParentID.toString() === selectedParent
                                        else return true
                                    }).map((data) => <option value={data.ID} key={data.ID}>{data.Name}</option>)
                                }
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                ) 
            } else {
                return null
            }
        }

        // If category selected and the category have children
        if (
            filterState.selectedCategory &&
            filterState.selectedCategory !== "0"
        ) {
            subtypeInputs.push(
                createSubTypeInput(1, filterState.selectedCategory)
            )
            if(filterState.selectedCategorySubtypes){
                for (let [key, value] of Object.entries(filterState.selectedCategorySubtypes) ) {
                    subtypeInputs.push(createSubTypeInput(parseInt(key)+1, value))
                }
            }
        }
        
        console.log(subtypeInputs)

        return (
            <React.Fragment>
                {subtypeInputs.map((input) => input)}
            </React.Fragment>
        )
    }

    return (
        <Form>
            {
                sectionType === "delivered" &&
                <Form.Row>
                    <Form.Group as={Col} controlId="formGridState">
                        <Form.Label>Portos</Form.Label>
                        <Form.Control as="select" defaultValue="-" onChange={(e) => filterDispatchState({
                            ...filterState,
                            selectedPort: e.target.value
                        })}>
                            <option value={"0"}> - </option>
                            {
                                filterState.filterData && filterState.filterData.portData.map((data) => <option value={data.ID} key={data.ID}>{data.Name}</option>)
                            }
                        </Form.Control>
                    </Form.Group>
                </Form.Row>
            }
            <Form.Row>
                <Form.Group as={Col} controlId="formGridState">
                    <Form.Label>Categoria</Form.Label>
                    <Form.Control as="select" defaultValue="-" onChange={(e) => {
                        filterDispatchState({
                            ...filterState,
                            selectedCategory: e.target.value,
                            selectedCategorySubtypes: undefined,
                            selectedType: "-"
                        })
                    }}>
                        <option value={"0"}>-</option>
                        {
                            filterState.filterData && filterState.filterData.categoryData.map((data) => <option value={data.ID} key={data.ID}>{data.Name}</option>)
                        }
                    </Form.Control>
                </Form.Group>
            </Form.Row>
            {SubTypesFilter()}
            <Form.Row>
                <p className="mb-2">{"Data Inicial: "}</p>
                <DatePicker
                    selected={filterState.selectedStartDate}
                    onChange={(date) => {
                        filterDispatchState({
                            ...filterState,
                            selectedStartDate: date,
                        })
                    }}
                    selectsStart
                    startDate={filterState.selectedStartDate}
                    endDate={filterState.selectedEndDate}
                    maxDate={filterState.selectedEndDate}
                    onFocus={(e) => e.target.readOnly = true}
                    locale="pt"
                    dateFormat="d, MMMM, yyyy"
                    className="form-control bg-custom-light-gray gray-border"
                    wrapperClassName="w-100"
                    placeholderText={"Selecionar..."}
                />
                <p className="mb-2 mt-3">{"Data Final: "}</p>
                <DatePicker
                    selected={filterState.selectedEndDate}
                    onChange={(date) => {
                        filterDispatchState({
                            ...filterState,
                            selectedEndDate: date,
                        })
                    }}
                    selectsEnd
                    startDate={filterState.selectedStartDate}
                    endDate={filterState.selectedEndDate}
                    minDate={filterState.selectedStartDate}
                    onFocus={(e) => e.target.readOnly = true}
                    maxDate={new Date()}
                    locale="pt"
                    dateFormat="d, MMMM, yyyy"
                    className="form-control bg-custom-light-gray gray-border"
                    wrapperClassName="w-100"
                />
            </Form.Row>

        </Form>
    )
}